export default __webpack_public_path__ + "static/media/back-to-dashboard.73fe4cf5.svg";